// Datepicker
import 'dayjs/locale/es';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";

import { useTranslation } from "react-i18next";

// Components
import { CustomButtonV2, CustomFormLabel, ModalFooter, ModalHeader, ModalSubHeader } from '../../../../pages/styles';
import {
    Container,
    Body,
    BoxContainer,
    SectionRight,
    ContainerDates,
    ContainerGroup,
    InputsDate,
} from './style';
import { ClearIconButton } from '../FiltersWorkflowModalCard/style';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'moment/locale/de';
import moment from "moment";
import { CleaningServicesRounded } from '@mui/icons-material';

export const RevalidationsExcelDownload = ({datesDownloadValid, setOpendownloadValidations, handleChangeDateDownload, handleDownloadExcel, errorsDate, handleClearDates }) => {

  const { t } = useTranslation();
  dayjs.locale('es');


    return (
        <Container>
            <ModalHeader>Descargar revalidaciones</ModalHeader>
            <ModalSubHeader/>
            <Body>
                <CustomFormLabel sx={{ marginBottom: '20px', color: '#848485ff' }}>
                    {t('common.downloadExcel')}
                </CustomFormLabel>
                <BoxContainer>
                    <ContainerDates>
                        <ContainerGroup>
                            {/* Input desde */}
                            <InputsDate errorstart={errorsDate.startDate}>
                                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            label={t("common.initDate")}
                                            value={datesDownloadValid?.startDate ? moment(datesDownloadValid?.startDate) : null}
                                            //minDate={dayjs('2020-03-20')}
                                            //maxDate={dayjs()}
                                            minDate={moment('2020-03-20')}
                                            maxDate={moment()}
                                            onChange={e => handleChangeDateDownload(e || "", "startDate")}
                                            slotProps={{ textField: { size: 'small', error: errorsDate.startDate, required: errorsDate.startDate } }}
                                            format="DD/MM/YYYY"
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </InputsDate>
                            {/* Input hasta */}
                            <InputsDate errorend={errorsDate.endDate}>
                                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            label={t("common.lastDate")}
                                            //value={moment(datesDownloadValid?.endDate)}
                                            value={datesDownloadValid?.endDate ? moment(datesDownloadValid?.endDate) : null}
                                            //minDate={dayjs(datesDownloadValid?.startDate)}
                                            //maxDate={dayjs()}
                                            minDate={moment(datesDownloadValid?.startDate)}
                                            maxDate={moment()}
                                            onChange={(e) => handleChangeDateDownload(e || "", "endDate")}
                                            slotProps={{ textField: { size: 'small', error: errorsDate.endDate, required: errorsDate.endDate } }}
                                            format="DD/MM/YYYY"
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </InputsDate>
                        </ContainerGroup>
                    </ContainerDates>

                    <CustomButtonV2
                        btnType="close"
                        aria-label="plot"
                        sx={{ width: '100px' }}
                        onClick={handleClearDates}
                        startIcon={<CleaningServicesRounded/>}
                    >
                        {t('common.clean')}
                    </CustomButtonV2>
                </BoxContainer>
            </Body>
            <ModalFooter>
                <SectionRight>
                    <CustomButtonV2
                      btnType="secondary"
                      onClick={() => setOpendownloadValidations(false)} 
                      variant="outlined">{t('common.cancel')}
                    </CustomButtonV2>
                    <CustomButtonV2
                      btnType="primary"
                      onClick={handleDownloadExcel}>{t('common.download')}
                    </CustomButtonV2>
                </SectionRight>
            </ModalFooter>
        </Container>
    )
}
